import { FaWhatsapp } from "react-icons/fa";

const WhatsAppFloatingButton = () => {
  const phoneNumber = "919179333330";
  const message = encodeURIComponent(
    "Hello! I need assistance with  Matrimony.",
  );

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 text-white rounded-full p-3 shadow-lg hover:bg-green-600 hover:scale-105 transition transform"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp size={20} />
    </a>
  );
};

export default WhatsAppFloatingButton;
